<div class="mt-2.5 w-full">
  @for (result of results(); track result.ehid; let resultIndex = $index) {
    <div class="nx-margin-bottom-s nx-margin-top-s w-full" [attr.data-testid]="'company-search-results-' + resultIndex">
      <nx-card class="w-full">
        <h3 nxHeadline="subsection-small">
          {{ result.name }}
        </h3>
        <div class="company-info">
          <span>{{ result.streetNumber }} {{ result.streetName }} • {{ result.postCode }} • {{ result.town }}</span> •
          <span class="nx-font-weight-bold">{{ getCountryLabel(result.countryCode) }}</span> •
          {{ result.nationalIdentifier?.idTypeCode }}:
          <span class="nx-font-weight-bold">{{ result.nationalIdentifier?.idValue }}</span> | EH ID:
          <span class="nx-font-weight-bold">{{ result.ehid }}</span>
        </div>
        <div class="centered mt-2.5">
          @for (buttonData of buttonsData()[resultIndex]; track $index) {
            <div class="flex flex-col items-center">
              <div [class]="buttonData.class">
                <button
                  [nxButton]="buttonData.nxButton"
                  type="button"
                  [disabled]="isLoading() || buttonData.disabled"
                  (click)="buttonData.onSelect(resultIndex)"
                  class="flex items-center"
                >
                  {{ buttonData.i18n | translate }}
                </button>
              </div>
              @if (buttonData.errorI18n; as errorI18n) {
                <nx-error appearance="text" class="mt-2">{{ errorI18n | translate }}</nx-error>
              }
            </div>
          }
          <nx-spinner
            [class]="isLoading() || isIterationLoading()?.(resultIndex) ? 'self-center' : 'invisible'"
            data-testid="company-search-results-iteration-spinner"
          />
        </div>
      </nx-card>
    </div>
  } @empty {
    <div class="flex justify-center items-center flex-col mt-2.5">
      <nx-icon name="search" size="l" aria-hidden="true" class="search-icon my-2.5" />
      <h4 nxHeadline="subsection-xsmall" class="nx-font-weight-semibold mt-2.5">
        {{ 'company-search.no-results' | translate }}
      </h4>
      <h4 nxHeadline="subsection-xsmall" class="nx-margin-top-s nx-font-weight-light">
        {{ 'company-search.modify-search' | translate }}
      </h4>
    </div>
  }
</div>
